// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsWJzwHMgdfBJUcXyZlGpuFUUxqcFGJMk",
  authDomain: "bifrostkey.firebaseapp.com",
  projectId: "bifrostkey",
  storageBucket: "bifrostkey.firebasestorage.app",
  messagingSenderId: "369009895214",
  appId: "1:369009895214:web:3a483488ad235ce43a7cbf",
  measurementId: "G-EPZ55ZKCWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app, 'europe-west3');
export const auth = getAuth(app);

// Uncomment the following line to use the local functions emulator
// connectFunctionsEmulator(functions, "localhost", 5001);
